import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { Tooltip } from "@material-ui/core";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as config from "@Configs/globalConfig";

import { getNotify, addNotify } from "@Actions/notifyActions";

import SettingBadge from "./SettingBadge";
import LogToggleButton from "./LogToggleButton";
import AvatarBadge from "./AvatarBadge";
import LogoutBadge from "./LogoutBadge";
import SearchBar from "@Components/SearchBar";
import CaseTodosBadge from "./CaseTodosBadge";

import ProgressBar from "@Components/ProgressBar";
import styles from "./styles";

class TopMenu extends Component {
  constructor(props) {
    super();
  }

  componentDidMount() {
    this.props.getNotify();
    if (localStorage.getItem("HasBothPortals") === "true") {
      this.hasBothPortals = true;
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appBar}>
          <ProgressBar />
          <Toolbar className={classes.toolbar}>
            <Link to="/domains" className={classes.link}>
              <img
                className={classes.imgStyle}
                src={require("@Assets/images/logo.png")}
                alt=""
              />
            </Link>
            <div className={classes.flex}>
              <SearchBar />
            </div>
            <AvatarBadge avatar={this.props.globalReducer.userInfo.avatar} />

            <Link to="/setting" className={classes.link}>
              <SettingBadge />
            </Link>

            {(this.hasBothPortals || true )&& (
              <>
                <Tooltip title="Switch App">
                  <div
                    className={classes.user_icon}
                    style={{ width: 25, height: 25, fill: "#616161", cursor: "pointer" }}
                    onClick={(event) => {
                      window.location.href = config.FLP_PORTAL_URL;
                    }}
                  >
                    <svg
                      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1phnduy"
                      focusable="false"
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                    >
                      <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-6 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m6 12H8v-1.5c0-1.99 4-3 6-3s6 1.01 6 3z"></path>
                    </svg>
                  </div>
                </Tooltip>
              </>
            )}

            <LogoutBadge />

            <CaseTodosBadge />
            <LogToggleButton />
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

TopMenu.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    notifyReducer: state.notifyReducer,
    globalReducer: state.globalReducer,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNotify: getNotify,
      addNotify: addNotify,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps,
)(withStyles(styles)(TopMenu));
